import { Logger as log } from './Logger.js';
import { browserTracingIntegration } from '@sentry/browser';
import { init } from '@sentry/react';
export { captureException, captureMessage, setUser, showReportDialog, withScope, } from '@sentry/browser';
export { ErrorBoundary } from '@sentry/react';
export const createSentry = ({ dsn, environment, release, }) => {
    log.debug('sentry initialized');
    return init({
        debug: sessionStorage.getItem('CONTRA_SESSION_DEBUG_SENTRY') === 'true',
        denyUrls: [
            // Chrome Extensions
            /extensions\//iu,
            /^chrome:\/\//iu,
            // Safari Extensions
            /safari-extension/u,
            /^app:\/\//iu,
        ],
        dsn,
        environment,
        ignoreErrors: [
            // We do not support browsers that do not implement ResizeObserver.
            /ResizeObserver/u,
            // There is a side-effect in ical.js dependency that is causing this error on every page.
            /ICAL/u,
            // Often caused by users with unstable internet connections or otherwise errors calling fetch in userland.
            /TypeError: Failed to fetch/u,
        ],
        integrations: [browserTracingIntegration()],
        normalizeDepth: 6,
        profilesSampleRate: 0,
        release,
        tracePropagationTargets: [
            'https://contra.com/api/',
            'https://local.contra.dev:8080/api/',
            '/api/',
        ],
        tracesSampleRate: 1,
        tunnel: '/sentry',
    });
};
//# sourceMappingURL=react.js.map